import RootLayout from "@/app/layout";
import data from '../../data/angebot/data.json';
import { DetailAngebotSection } from "@/app/components/Sections/DetailAngebotSection";
import Head from "next/head";

export const metadata = {
    title: 'Hebamme Lea Stiffler | Akupunktur',
    description: 'Entdecken Sie die Vorteile von Akupunktur während der Schwangerschaft in Chur. Linderung von Beschwerden und optimale Vorbereitung auf die Geburt durch erfahrene Hebamme.',
    keywords: 'Akupunktur Schwangerschaft, Beschwerden Linderung, Geburtsvorbereitung Akupunktur, Hebamme Chur, Schwangerschaftsbeschwerden, Vorbereitung Geburt',
    canonicalUrl: 'https://hebamme-leastiffler.ch/akupunktur'
}

export async function getStaticProps() {
    return { props: { data } }
}

export default function Akupunktur({ data }) {
    const akupunkturData = data.Akupunktur;

    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <DetailAngebotSection data={akupunkturData} />
        </RootLayout>
    );
}